import React from "react";

/* Lightweight inline-SVG icon set — no external icon dependency, crisp at any size.
   Usage: <Icon name="chat" size={24} /> (inherits currentColor). */

const PATHS = {
  chat: (
    <path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.5 9.5 9.5 0 0 1-4-.9L3 20l1.4-4.5A8.5 8.5 0 0 1 12.5 3 8.38 8.38 0 0 1 21 11.5Z" />
  ),
  gears: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z" />
    </>
  ),
  cart: (
    <>
      <circle cx="9" cy="21" r="1.4" />
      <circle cx="19" cy="21" r="1.4" />
      <path d="M2.5 3h2l2.2 12.4a2 2 0 0 0 2 1.6h8.6a2 2 0 0 0 2-1.6L21.5 7H6" />
    </>
  ),
  phone: (
    <>
      <rect x="6.5" y="2.5" width="11" height="19" rx="2.4" />
      <path d="M11 18.5h2" />
    </>
  ),
  chip: (
    <>
      <rect x="6.5" y="6.5" width="11" height="11" rx="2" />
      <path d="M9.5 2.5v3M14.5 2.5v3M9.5 18.5v3M14.5 18.5v3M2.5 9.5h3M2.5 14.5h3M18.5 9.5h3M18.5 14.5h3" />
      <rect x="10" y="10" width="4" height="4" rx="0.6" />
    </>
  ),
  flask: (
    <path d="M9 2.5h6M10 2.5v6.2L4.8 18a2 2 0 0 0 1.8 3h10.8a2 2 0 0 0 1.8-3L14 8.7V2.5M7.5 14.5h9" />
  ),
  chart: (
    <>
      <path d="M3 3v18h18" />
      <path d="M7 15l3-4 3 3 4-6" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.2 2" />
    </>
  ),
  rocket: (
    <path d="M5 15c-1.5 1.5-2 5-2 5s3.5-.5 5-2c.9-.9.9-2.4 0-3.4a2.4 2.4 0 0 0-3 .4ZM9 13l-2-2c1-4 4-7.5 8-8 .5 4-2 8-6 10ZM15 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
  ),
  brain: (
    <path d="M9.5 3A2.5 2.5 0 0 0 7 5.5 2.5 2.5 0 0 0 4.5 8c0 1 .5 1.8 1.2 2.3A2.6 2.6 0 0 0 4.5 12.5c0 1 .5 1.8 1.2 2.3-.4.5-.7 1.1-.7 1.7A2.5 2.5 0 0 0 7.5 19 2.5 2.5 0 0 0 10 21.5V3.5A.5.5 0 0 0 9.5 3ZM14.5 3a.5.5 0 0 0-.5.5v18A2.5 2.5 0 0 0 16.5 19a2.5 2.5 0 0 0 2.5-2.5c0-.6-.3-1.2-.7-1.7.7-.5 1.2-1.3 1.2-2.3a2.6 2.6 0 0 0-1.2-2.2c.7-.5 1.2-1.3 1.2-2.3A2.5 2.5 0 0 0 17 5.5 2.5 2.5 0 0 0 14.5 3Z" />
  ),
  spark: (
    <path d="M12 2.5l1.9 5.6 5.6 1.9-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9L12 2.5ZM19 15l.8 2.2 2.2.8-2.2.8L19 21l-.8-2.2-2.2-.8 2.2-.8L19 15Z" />
  ),
  signal: (
    <>
      <path d="M5 18a10 10 0 0 1 14 0M8 15a6 6 0 0 1 8 0M11 12a2 2 0 0 1 2 0" />
      <circle cx="12" cy="19.5" r="1" />
    </>
  ),
  shield: (
    <path d="M12 2.5l7.5 3v5.5c0 5-3.4 8.6-7.5 10-4.1-1.4-7.5-5-7.5-10V5.5L12 2.5ZM9 12l2 2 4-4" />
  ),
  users: (
    <>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3.5 20a5.5 5.5 0 0 1 11 0M16 5.2a3.2 3.2 0 0 1 0 6M17.5 14.5a5.5 5.5 0 0 1 3 5" />
    </>
  ),
  team: (
    <>
      <circle cx="12" cy="7" r="3" />
      <circle cx="5.5" cy="10" r="2.2" />
      <circle cx="18.5" cy="10" r="2.2" />
      <path d="M6.5 20a5.5 5.5 0 0 1 11 0M2.5 19a3.6 3.6 0 0 1 3-3.4M21.5 19a3.6 3.6 0 0 0-3-3.4" />
    </>
  ),
  check: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M8 12.5l2.5 2.5L16 9" />
    </>
  ),
  award: (
    <>
      <circle cx="12" cy="9" r="5.5" />
      <path d="M8.5 13.5L7 21l5-2.5L17 21l-1.5-7.5" />
    </>
  ),
  coffee: (
    <>
      <path d="M4 8h13v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V8Z" />
      <path d="M17 9h2.2a2.3 2.3 0 0 1 0 4.6H17" />
      <path d="M7 2.5c-.6 1 .6 1.8 0 2.8M11 2.5c-.6 1 .6 1.8 0 2.8" />
    </>
  ),
  bot: (
    <>
      <rect x="5" y="8" width="14" height="10" rx="3" />
      <path d="M12 4.5V8M9 13h.01M15 13h.01M9.5 16h5" />
      <circle cx="12" cy="3.5" r="1.2" />
      <path d="M2.5 12.5v2M21.5 12.5v2" />
    </>
  ),
  arrow: <path d="M5 12h14M13 6l6 6-6 6" />,
  mail: (
    <>
      <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" />
      <path d="M3.5 6.5l8.5 6 8.5-6" />
    </>
  ),
  map: (
    <>
      <path d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11Z" />
      <circle cx="12" cy="10" r="2.5" />
    </>
  ),
  play: <path d="M7 4.5l12 7.5-12 7.5V4.5Z" />,
  instagram: (
    <>
      <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17" cy="7" r="1" />
    </>
  ),
  facebook: <path d="M14.5 8.5H17V5h-2.5A3.5 3.5 0 0 0 11 8.5V11H8.5v3.5H11V21h3.5v-6.5H17l.5-3.5h-3V8.8c0-.2.2-.3.5-.3Z" />,
  youtube: (
    <>
      <rect x="2.5" y="6" width="19" height="12" rx="4" />
      <path d="M10 9.5l5 2.5-5 2.5v-5Z" />
    </>
  ),
  linkedin: (
    <>
      <rect x="3.5" y="3.5" width="17" height="17" rx="3" />
      <path d="M8 10v7M8 7v.01M12 17v-4a2 2 0 0 1 4 0v4M12 17v-7" />
    </>
  ),
};

export default function Icon({ name, size = 24, strokeWidth = 1.7, className = "", style }) {
  const inner = PATHS[name] || PATHS.spark;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      style={style}
    >
      {inner}
    </svg>
  );
}
